var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadCloudIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8 20.0334H21.3066C24.2133 20.0334 26.3333 16.8067 26.3333 14.0867C26.3153 13.1992 26.1155 12.3248 25.7463 11.5176C25.3771 10.7104 24.8463 9.9874 24.1866 9.39337C23.1473 8.49783 21.7948 8.05179 20.4266 8.15337C20.3075 8.16628 20.1869 8.15542 20.072 8.12144C19.957 8.08745 19.8499 8.031 19.7569 7.95537C19.6639 7.87973 19.5869 7.7864 19.5302 7.68078C19.4735 7.57516 19.4383 7.45935 19.4266 7.34004C18.88 -1.35329 5.86665 -1.23329 5.66665 7.70004C5.66344 7.88239 5.60762 8.05993 5.50591 8.21131C5.4042 8.3627 5.26092 8.48148 5.09331 8.55337C3.8609 9.16375 2.8676 10.1682 2.27098 11.4073C1.67436 12.6464 1.50859 14.0493 1.79998 15.3934C1.96669 16.2306 2.30819 17.0231 2.80217 17.7193C3.29615 18.4155 3.93149 18.9995 4.66665 19.4334C5.58818 19.9333 6.6348 20.1556 7.67998 20.0734H9.34665",
    stroke: "#D79963",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.0867V10.8467",
    stroke: "#D79963",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1067 13.5134L14 10.6334L16.8933 13.5134",
    stroke: "#D79963",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudIcon);
export default __webpack_public_path__ + "static/media/uploadCloudIcon.1b469ed84d1fe173f29d11ddfe0acc4d.svg";
export { ForwardRef as ReactComponent };